/* eslint-disable @typescript-eslint/no-explicit-any */
import { LocalDate } from 'js-joda';
import { find, isUndefined, toInteger, toNumber } from 'es-toolkit/compat';

function isValidDate(date: string) {
  try {
    LocalDate.parse(date);
  } catch (_error) {
    return false;
  }
  return true;
}

function isValidExperienceId(experienceId: number | undefined, ticketType?: any) {
  return (
    isUndefined(experienceId) ||
    !isUndefined(ticketType) ||
    !isUndefined(find(ticketType, { id: toNumber(experienceId) }))
  );
}

function isValidPartySize(partySize: number | string | undefined) {
  return isUndefined(partySize) || toInteger(partySize) > 0;
}

function isValidTime(time: any) {
  // matches between 00:00 and 23:59 (requires double digits for both hours and minutes)
  const re = new RegExp('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
  return re.test(time);
}

export default {
  isValidDate,
  isValidExperienceId,
  isValidPartySize,
  isValidTime,
};
